import React from "react";
import { useSearchParams } from "react-router-dom";

interface CreditProps {
  producers?: Array<{
    name: string;
    logo?: string;
    url?: string;
  }>;
  supporters?: Array<{
    name: string;
    logo?: string;
    url?: string;
  }>;
}

export const Credit: React.FC<CreditProps> = ({ 
  producers = [],
  supporters = [] 
}) => {
  const [searchParams] = useSearchParams();
  const locale = searchParams.get('locale') || 'en';

  const getFontClass = () => {
    return locale === 'np' ? 'font-noto' : 'font-slate';
  };

  const getTitle = (key: 'produced' | 'supported') => {
    if (locale === 'np') {
      return key === 'produced' ? 'उत्पादक:' : 'सहयोगी:';
    }
    return key === 'produced' ? 'Produced by:' : 'Supported by:';
  };

  return (
    <section className="w-full py-12 mt-8">
      <div className="max-w-[500px] mx-auto px-4">
        {/* <h2 className={`text-[rgba(0,63,40,1)] text-2xl font-bold mb-8 text-center ${getFontClass()}`}>
          {locale === 'np' ? 'क्रेडिट' : 'Credits'}
        </h2> */}

        {producers.length > 0 && (
          <div className="mb-10">
            <h3 className={`text-[rgba(0,63,40,1)] text-xl font-medium mb-5 text-center ${getFontClass()}`}>
              {getTitle('produced')}
            </h3>
            <div className="flex flex-wrap gap-8 justify-center">
              {producers.map((producer, index) => (
                <div key={index} className="flex flex-col items-center">
                  {producer.logo ? (
                    <a 
                      href={producer.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="flex items-center justify-center w-32 h-32 mb-3"
                    >
                      <img 
                        src={producer.logo} 
                        alt={producer.name} 
                        className="max-w-full max-h-full object-contain" 
                      />
                    </a>
                  ) : null}
                  <span className={`text-[rgba(0,63,40,1)] text-base font-medium text-center ${getFontClass()}`}>{producer.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {supporters.length > 0 && (
          <div>
            <h3 className={`text-[rgba(0,63,40,1)] text-xl font-medium mb-5 text-center ${getFontClass()}`}>
              {getTitle('supported')}
            </h3>
            <div className="flex flex-wrap gap-8 justify-center">
              {supporters.map((supporter, index) => (
                <div key={index} className="flex flex-col items-center">
                  {supporter.logo ? (
                    <a 
                      href={supporter.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="flex items-center justify-center w-32 h-32 mb-3"
                    >
                      <img 
                        src={supporter.logo} 
                        alt={supporter.name} 
                        className="max-w-full max-h-full object-contain" 
                      />
                    </a>
                  ) : null}
                  <span className={`text-[rgba(0,63,40,1)] text-base font-medium text-center max-w-[200px] ${getFontClass()}`}>{supporter.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
